export default "__VITE_ASSET__DXhkGkcu__"